<template>
  <div class="admin_category container">
    <v-card>
      <v-card-title>
        <v-btn color="indigo" dark class="mb-2" rounded small @click="back"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
        <v-divider class="mx-4" inset vertical></v-divider> 
        {{ $t('dashboard_pay') }}<!-- How Do you Want Customers to pay You, Sweetalert -->
      </v-card-title>
      <v-data-table :headers="headers" :items="payments" :search="search" sort-by="slug" class="elevation-1">
        <template v-slot:top>
          <div class="hidden-md-and-up container">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
          </div>
          <v-toolbar flat color="white">
            <div class="hidden-sm-and-down">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </div>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:item.name="{ item }">
          <router-link 
            :to="{ name: 'admin_subcategory_products', 
            params: { slug: item.slug }}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <b>{{ item.name }} +</b>
                </span>
              </template>
              <span>Modal Form</span>
            </v-tooltip>
          </router-link>
        </template>
        <template v-slot:item.action="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editPayment(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              @click="deletePayment(item)"
            >
              mdi-delete
            </v-icon>
        </template>
        <template v-slot:no-data>
          <v-list-item-title><b>Please Add A Payment</b></v-list-item-title>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import {db} from '@/firebase';
  
  export default {
    data: () => ({
      dialog: false,
      status: [
        0,1
      ],
      priority: [
        0,1
      ],
      payment_code: [
        'ZMK',
        'ZIM'
      ],
      town_code: [
        'LSK'
      ],
      search: '',
      headers: [
        { text: 'ClientID', align: 'left', value: 'name' },
        { text: 'Paid Through', value: 'priority' },
        { text: 'Total', value: 'priority' },
        { text: 'Comm. Received', value: 'priority' },
        { text: 'Date', value: 'priority' },
        { text: 'Pay_Status', value: 'status' },//Not Yet Paid //In Process //Paid
        { text: 'Actions', value: 'action', sortable: false },
      ],
      payments: [],
      editedIndex: -1,
      payment: {
        name: '',
        slug: '',
        type: '',
        description: '',
        status: '',
        priority: '',
        movements: [],
        payment_code: [],
        town_code: []
      },
      activeItem: '',
      modal: ''
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Payment' : 'Edit Payment'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    firestore() {
      return {
        payments: db.collection('payments')
      }
    },

    methods: {
      back(){
        this.$router.go(-1)
      },
      
      reset(){
        this.payment = {
          name: '',
          slug: '',
          type: '',
          description: '',
          status: '',
          priority: '',
          movements: [],
          payment_code: [],
          town_code: []
        }  
      },

      addNew(){
        this.modal = 'new'
        this.reset()
        this.dialog = true
      },

      addPayment(){
        this.$firestore.payments.add(this.payment)
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'Payment created successfully'
        })
        /* eslint-enable */
        this.close()
      },
      
      updatePayment(){
        this.$firestore.payments.doc(this.payment.id).update(this.payment)
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'Payment System updated successfully'
        })
        /* eslint-enable */
        this.close()
      },

      editPayment(item) {
        this.editedIndex = this.payments.indexOf(item)
        this.payment = Object.assign({}, item)
        this.modal = 'edit'
        this.prodialog = true
      },

      deletePayment(item) {
        /* eslint-disable */
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.$firestore.payments.doc(item.id).delete()            

            Toast.fire({
              type: 'success',
              title: 'Deleted successfully'
            })
          }
        })
        /* eslint-enable */
      }, 

      close () {
        this.dialog = false
        setTimeout(() => {
          this.payment = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      }
    },
  }
</script>
